import PropTypes from 'prop-types';

import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import { Badge, Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

const MessagesButton = (props) => {
  const { t } = useTransl();
  const theme = useTheme();
  const { onClick, hasNewNotifications } = props;
  return (
    <Button
      disableElevation
      onClick={onClick}
      sx={{
        marginLeft: '-1rem',
      }}
    >
      <Box display="flex" gap="1rem">
        <Badge
          color="secondary"
          variant="dot"
          overlap="circular"
          invisible={!hasNewNotifications}
        >
          <MailOutlinedIcon />
        </Badge>
        <Typography color={theme.palette.text.primary}>
          {t('title.messages')}
        </Typography>
      </Box>
    </Button>
  );
};

MessagesButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  hasNewNotifications: PropTypes.bool.isRequired,
};

export default MessagesButton;
